import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";

//  Organization Address

export const getAddress = (pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("getAddress");
  return trackPromise(Call.get(url));
};

export const addNewAddress = (payload) => {
  const url = getUrl("addNewAddress");
  return trackPromise(Call.post(url, payload));
};

export const updateAddress = ({org_address_id}, payload) => {
  const url = getUrl("updateAddress")(org_address_id);
  return trackPromise(Call.patch(url, payload));
};

export const deleteAddress = ({org_address_id}) => {
  const url = getUrl("deleteAddress")(org_address_id);
  return trackPromise(Call.delete(url));
};
